__turbopack_context__.v({
  "benIntro": "BreadCrumb-module__Oh18Tq__benIntro",
  "benPageDesk": "BreadCrumb-module__Oh18Tq__benPageDesk",
  "benPageImg": "BreadCrumb-module__Oh18Tq__benPageImg",
  "benPageImgDesk": "BreadCrumb-module__Oh18Tq__benPageImgDesk",
  "benPageImgImg": "BreadCrumb-module__Oh18Tq__benPageImgImg",
  "benPageProBlock": "BreadCrumb-module__Oh18Tq__benPageProBlock",
  "benPageTablet": "BreadCrumb-module__Oh18Tq__benPageTablet",
  "benPageTitle": "BreadCrumb-module__Oh18Tq__benPageTitle",
  "breadcrumb": "BreadCrumb-module__Oh18Tq__breadcrumb",
  "breadcrumbtab": "BreadCrumb-module__Oh18Tq__breadcrumbtab",
  "btnalign": "BreadCrumb-module__Oh18Tq__btnalign",
  "callwword": "BreadCrumb-module__Oh18Tq__callwword",
  "detailCol": "BreadCrumb-module__Oh18Tq__detailCol",
  "detailRow": "BreadCrumb-module__Oh18Tq__detailRow",
  "donate": "BreadCrumb-module__Oh18Tq__donate",
  "dotaneTxt": "BreadCrumb-module__Oh18Tq__dotaneTxt",
  "profileHeading": "BreadCrumb-module__Oh18Tq__profileHeading",
  "tag": "BreadCrumb-module__Oh18Tq__tag",
  "tagContainer": "BreadCrumb-module__Oh18Tq__tagContainer",
});
